import React, { useImperativeHandle, useRef, useState } from "react";
import { Fab, IconButton, Paper, Divider, makeStyles } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import { fillThemeColor } from "../theme/color";
import { invalid, type, empty } from "../../utils/common";
import { Scrollbar } from "../Scrollbar";
import { createIcon } from "../common";
import { runtime } from "@codeArt/common";

function getTheme(theme, titleLine) {
  switch (theme) {
    case "flat":
      return {
        radius: "0",
        headerClassName: "",
        iconClassName: "text-grey c-icon-s3 mr-2",
        titleClassName: "text-dark",
        containerPadding: "p-0",
        elevation: 0,
        bodyClassName: ""
      };
    case "card":
      return {
        radius: "0.375rem",
        headerClassName: "",
        iconClassName: "text-white c-icon-s4 mr-2",
        titleClassName: "text-white",
        containerPadding: "p-3",
        elevation: 4,
        bodyClassName: ""
      };
    case "panel":
      return {
        radius: "0.1rem",
        headerClassName: `${titleLine ? "c-lb" : ""} py-3 px-4`,
        iconClassName: "text-grey c-icon-s3 mr-2",
        titleClassName: "text-dark",
        containerPadding: "p-0",
        elevation: 4,
        bodyClassName: "p-3"
      };
    default:
  }
}

const useStyles = makeStyles(theme => {
  return {
    root: ({ width, height }) => ({
      ...(invalid(width) ? null : { width }),
      ...(invalid(height) ? null : { height })
    }),
    flat: {
      background: "none"
    },
    narrow: {
      width: "1300px",
      margin:"0 auto",
      // alignSelf: "center !important",
      [theme.breakpoints.down(1300)]: {
        width: '100%',
      },
    }
  };
});

// const Portal = ({
//   theme,
//   color,
//   icon,
//   title,
//   tools,
//   children,
//   className,
//   elevation,
//   radius,
//   iconClassName,
//   containerPadding,
//   headerClassName,
//   titleClassName,
//   bodyClassName,
//   header,
//   full,
//   height,
//   width,
//   face,
//   flat,
//   scrollable,
//   narrow,
//   titleLine
// }) => {
//   if (flat) theme = "flat";
//   let arg = getTheme(theme, titleLine);
//   if (color) arg["color"] = color;
//   if (!empty(elevation)) arg["elevation"] = elevation;
//   if (!empty(radius)) arg["radius"] = radius;
//   if (iconClassName)
//     arg["iconClassName"] = arg["iconClassName"] + " " + iconClassName;
//   if (containerPadding) arg["containerPadding"] = containerPadding;
//   if (bodyClassName)
//     arg["bodyClassName"] = arg["bodyClassName"] + " " + bodyClassName;

//   let faceClassName = face && !flat ? "shadow-xs c-l" : "";

//   const classes = useStyles({ width, height });

//   let props = fillThemeColor(
//     {
//       style: { borderRadius: arg.radius },
//       className: `${classes.root} c-portal ${theme === "flat" || flat
//         ? classes.flat
//         : ""} ${narrow
//           ? classes.narrow
//           : ""} ${arg.containerPadding} ${faceClassName} mb-0 d-flex flex-column ${full
//             ? "c-flex-1"
//             : ""} ${className}`
//     },
//     color,
//     true
//   );
//   icon = createIcon(icon, arg.iconClassName);

//   const renderHeader = () => {
//     if(typeof header === "object") return; //header自定义
//     if (header === "pc" && !runtime.pc) return;
//     if (header === "mo" && !runtime.mobile) return;

//     return icon || title || tools ? (
//       <div
//         className={`d-flex flex-row align-items-center justify-content-between ${arg.headerClassName} ${headerClassName}`}
//       >
//         <div className="d-flex flex-row align-items-center">
//           {icon ? icon : null}
//           <h3 className={`m-auto ${arg.titleClassName} ${titleClassName}`}>
//             {title}
//           </h3>
//         </div>
//         <div className="c-protal-tools">{tools}</div>
//       </div>
//     ) : null;
//   };

//   const tryScrollable = content => {
//     return scrollable ? <Scrollbar>{content}</Scrollbar> : content;
//   };

//   return (
//     <Paper {...props} elevation={arg.elevation}>
//       {renderHeader()}
//       <div
//         className={`${arg.bodyClassName} ${full
//           ? "d-flex flex-column c-flex-1"
//           : ""} `}
//       >
//         {tryScrollable(children)}
//       </div>
//     </Paper>
//   );
// };



const Portal = React.forwardRef(({theme,
  color,
  icon,
  title,
  tools,
  children,
  className,
  elevation,
  radius,
  iconClassName,
  containerPadding,
  headerClassName,
  titleClassName,
  bodyClassName,
  header,
  full,
  height,
  width,
  face,
  flat,
  scrollable,
  narrow,
  titleLine}, ref) => {

  if (flat) theme = "flat";
  let arg = getTheme(theme, titleLine);
  if (color) arg["color"] = color;
  if (!empty(elevation)) arg["elevation"] = elevation;
  if (!empty(radius)) arg["radius"] = radius;
  if (iconClassName)
    arg["iconClassName"] = arg["iconClassName"] + " " + iconClassName;
  if (containerPadding) arg["containerPadding"] = containerPadding;
  if (bodyClassName)
    arg["bodyClassName"] = arg["bodyClassName"] + " " + bodyClassName;

  let faceClassName = face && !flat ? "shadow-xs c-l" : "";

  const classes = useStyles({ width, height });

  let props = fillThemeColor(
    {
      style: { borderRadius: arg.radius },
      className: `${classes.root} c-portal ${theme === "flat" || flat
        ? classes.flat
        : ""} ${narrow
          ? classes.narrow
          : ""} ${arg.containerPadding} ${faceClassName} mb-0 d-flex flex-column ${full
            ? "c-flex-1"
            : ""} ${className}`
    },
    color,
    true
  );

  icon = createIcon(icon, arg.iconClassName);

  useImperativeHandle(ref, () => ({
    scrollTop: scrollTop
  }));

  const renderHeader = () => {
    if(typeof header === "object") return; //header自定义
    if (header === "pc" && !runtime.pc) return;
    if (header === "mo" && !runtime.mobile) return;

    return icon || title || tools ? (
      <div
        className={`d-flex flex-row align-items-center justify-content-between ${arg.headerClassName} ${headerClassName}`}
      >
        <div className="d-flex flex-row align-items-center">
          {icon ? icon : null}
          <h3 className={`m-auto ${arg.titleClassName} ${titleClassName}`}>
            {title}
          </h3>
        </div>
        <div className="c-protal-tools">{tools}</div>
      </div>
    ) : null;
  };

  let scrollbar = useRef();

  const tryScrollable = content => {
    return scrollable ? <Scrollbar ref={scrollbar}>{content}</Scrollbar> : content;
  };

  const scrollTop = (top) => {
    scrollbar.current.scrollTop(top || 0);
  }

  return (
    <Paper {...props} elevation={arg.elevation}>
      {renderHeader()}
      <div
        className={`${arg.bodyClassName} ${full
          ? "d-flex flex-column c-flex-1"
          : ""} `}
      >
        {tryScrollable(children)}
      </div>
    </Paper>
  );
});



Portal.defaultProps = {
  header: "",
  theme: "panel", //panel card
  className: "",
  headerClassName: "",
  titleClassName:"c-text-s2",
  full: false,
  face: true,
  flat: false,
  narrow: false,
  scrollable: false,
  titleLine: true
};

Portal.detailProps = {
  narrow: true,
  titleLine: false,
  titleClassName: runtime.mobile ? "c-text-s3" : "c-text-s4",
  headerClassName: "c-p-0",
  bodyClassName: "c-p-0",
  className: runtime.mobile ? "c-py-2d5 c-px-3 my-2" : "c-py-4d5 c-px-5 my-2"
};

Portal.detailFlatProps = {
  ...Portal.detailProps,
  flat: true,
  className: runtime.mobile ? "c-py-0 c-px-1 my-2" : "c-py-0 c-px-5 my-2",
  titleClassName: runtime.mobile ? "c-text-s3" : "c-text-s4 font-weight-normal",
};

Portal.detailModalProps = {
  flat: true,
  titleLine: false,
  titleClassName: "c-text-s3",
  headerClassName: "c-p-0",
  bodyClassName: "c-p-0",
  className: runtime.pc ? "c-py-3 c-px-4 c-my-2" : "c-p-0"
};

Portal.detailWideModalProps = {
  ...Portal.detailModalProps,
  className: runtime.pc ? "c-py-3 c-px-0 c-my-2" : "c-p-0"
};

export default Portal;

export const PortalContainer = ({ full = true, tools, children }) => {
  //用于镂空命令行的布局
  return (
    <Portal full={full} flat={true} headerClassName="c-pb-2d5" tools={tools}>
      <Portal full={full}>{children}</Portal>
    </Portal>
  );
};

export class PortalTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  renderDescription() {
    let { description } = this.props;
    return description ? (
      <div className="d-flex c-text-s2 m-text-dark-50">
        {type(description) === "string" ? (
          <p className="mb-0">{description}</p>
        ) : (
          description
        )}
      </div>
    ) : null;
  }

  render() {
    let {
      icon,
      iconClassName,
      title,
      className,
      tools,
      line,
      titleClassName,
      narrow,
      lineClassName
    } = this.props;
    return (
      <div
        className={`d-flex flex-column ${narrow
          ? "c-portal-narrow"
          : ""} ${className}`}
      >
        <div
          className={`d-flex flex-row align-items-center justify-content-between`}
        >
          <div className={`d-flex align-items-center justify-content-start`}>
            {createIcon(icon, `text-dark mr-2 ${iconClassName}`)}
            <h3 className={`text-dark mb-0 ${titleClassName}`}>{title}</h3>
          </div>
          {tools ? (
            <div className={`d-flex align-items-center `}>{tools}</div>
          ) : null}
        </div>
        {this.renderDescription()}
        {line ? <Divider className={lineClassName} /> : null}
      </div>
    );
  }
}

PortalTitle.defaultProps = {
  className: "mb-4",
  titleClassName: "c-text-s2 c-text-sm-s4",
  line: false,
  lineClassName: "mt-2"
};

PortalTitle.gapClassName = "c-mt-1 c-mb-3";


export class PoratlNarrow extends React.Component {   //该对象与Portal结合使用，实现Portal居中，滚动条局外的效果

  constructor(props) {
    super(props);
  }

  scrollTop(top) {
    this.scrollbar.scrollTop(top||0);
  }

  tryScrollable(content) {
    let { innerNarrow, scrollable, scrollViewClassName } = this.props;
    scrollViewClassName = innerNarrow ? `d-flex flex-column justify-content-start align-items-center ${scrollViewClassName}` : scrollViewClassName;

    return (
      scrollable ? (
        <Scrollbar ref={(r) => { this.scrollbar = r; }} viewClassName={scrollViewClassName}>
          {content}
        </Scrollbar>
      ) : content
    );
  }

  render() {
    let { children, className, animated, style, center, onClick, full } = this.props;
    className = className || '';
    animated = animated || false;
    if (center) {
      if (center === true) center = 1300;//默认1300
      style = runtime.pc ? { width: center, ...style } : { ...style };
    }

    let props = {};
    if (onClick) {
      props.onClick = (e) => { onClick(e); }
    }

    return (
      <div className={`${animated ? 'animated slideInUpTiny animation-duration-3' : ''} c-container ${center ? 'c-container-center' : ''}  d-flex flex-column ${full ? 'h-100' : ''} ${className}`} style={style} {...props}>
        {this.tryScrollable(children)}
      </div>
    )
  }
}

PoratlNarrow.defaultProps = {
  innerNarrow:true,
  full:true,
  scrollable:true
}

// PoratlNarrow.defaultProps = {
//   full: true,
//   scrollable: false,
//   scrollViewClassName: ''
// }




